import { Injectable } from '@angular/core';
import { UserAsset } from '@interfaces';

type ChatAttachmentsToAdd = Record<
  string,
  {
    error: any;
    loading: boolean;
    uploaded: boolean;
    userAsset: UserAsset;
  }
>;

export interface ChatAttachmentItem {
  fileOriginalName: string;
  error: any;
  loading: boolean;
  uploaded: boolean;
  userAsset: UserAsset;
}

@Injectable({ providedIn: 'root' })
export class ChatAttachmentsService {
  public mapAttachments(items: ChatAttachmentsToAdd): ChatAttachmentItem[] | null {
    const values = Object.values(items || {});

    if (!values.length) {
      return null;
    }

    return values.map(({ error, loading, uploaded, userAsset }) => ({
      fileOriginalName: userAsset?.fileOriginalName || 'MISSING-DATA',
      error,
      loading,
      uploaded,
      userAsset,
    }));
  }

  public getUploadedAttachmentIds(attachments: ChatAttachmentItem[] | null): string[] {
    return (attachments || []).filter(attachment => attachment.uploaded).map(attachment => attachment.userAsset.id);
  }
}
